const TOKEN_KEY = 'token';
const USER_KEY = 'user';

export const get = (key) => {
  return window.localStorage.getItem(key);
};

export const save = (key, item) => {
  return window.localStorage.setItem(key, item);
};

export const destroy = (key) => {
  return window.localStorage.removeItem(key);
};

export const getToken = () => {
  return window.localStorage.getItem(TOKEN_KEY);
};

export const saveToken = token => {
  window.localStorage.setItem(TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(TOKEN_KEY);
};

export const getUser = () => {
  return window.localStorage.getItem(USER_KEY);
};

export const saveUser = user => {
  window.localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const destroyUser = () => {
  window.localStorage.removeItem(USER_KEY);
};

export default { get, save, destroy, getToken, saveToken, destroyToken, getUser, saveUser, destroyUser };
